<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStatusStore } from '@state/stores/status'

// Going back two entries: one for the page being left, one for the entry the
// router is about to push on top of it.
const HISTORY_STEPS_CONSUMED = 2

const statusStore = useStatusStore()
const router = useRouter()

const historyLength = computed(() => statusStore.historyLength)

const isVisible = computed(() => historyLength.value > 1)

function goBack() {
    router.go(-1)
    statusStore.setHistoryLength(historyLength.value - HISTORY_STEPS_CONSUMED)
}
</script>

<template>
    <a
        :class="['back-arrow', isVisible && 'back-arrow-visible']"
        @click="goBack"
    >
        <BaseIcon
            class="arrow"
            name="arrow-left"
        />
    </a>
</template>

<style lang="scss" scoped>
@import '@design';

.back-arrow {
    z-index: $layer-overlay-z-index;
    visibility: hidden;
    cursor: pointer;

    &-visible {
        visibility: visible;
    }
}

.arrow {
    width: $s-m;
    height: $s-xl;
    fill: $c-white;
}
</style>
